<template>
  <div class="about">
    <div class="banner">
      <el-image :src="require('../../assets/home/aboutbanner.png')" class="banner-img"></el-image>
    </div>
    <div class="tag">
<div class="title">
        <div class="slogan">能源行业 信心之选</div>
        <div class="sloganen">CONFIDENCE IN THE ENERGY SECTOR</div>
</div>
    </div>
      <div id="about-meau">
        <el-tabs v-model="activeName" @tab-click="aboutMenuSelect" >
        <el-tab-pane v-for="item in menus" :key="item.id" :name="item.type" :label=" item.name" style="font-size: 16px;">{{ item.name }}</el-tab-pane>
        </el-tabs>
      </div>
      <div class="about-meau-content" >
       <div v-show ="activeName!='teams'">
            <div  v-html="content.content" v-show="activeName=='culture' || activeName=='quality'"></div>
            <div class="ql-editor" v-html="content.content" v-show ="activeName!='culture'&& activeName!='quality'"></div>
        </div>
        <div v-show ="activeName=='teams'" style="box-shadow: 0px 4px 4px rgba(8, 59, 99, 0.3);">
            <el-row  >
              <el-col :span="8">
                <div class="add-left-title" >四川能信科技股份有限公司</div>

                  <el-row   class="add-left">
                  <el-col :span="3"  :offset="1" :style="{background:'url('+contact[0].url+')',backgroundSize:'100% 100%'}" class="add-left-img"></el-col>
                  <el-col :span="18"  class="add-left-content">电话： 028-83587010</el-col>
                  </el-row>
                  <el-row   class="add-left">
                  <el-col :span="3"  :offset="1" :style="{background:'url('+contact[1].url+')',backgroundSize:'100% 100%'}" class="add-left-img"></el-col>
                  <el-col :span="18"  class="add-left-content">邮箱： lensyn@lensyn.com</el-col>
                  </el-row>
                  <el-row   class="add-left">
                  <el-col :span="3"  :offset="1" :style="{background:'url('+contact[2].url+')',backgroundSize:'100% 100%'}" class="add-left-img"></el-col>
                  <el-col :span="18"  class="add-left-content">邮编：610093</el-col>
                  </el-row>
                  <el-row   class="add-left">
                  <el-col :span="3"  :offset="1" :style="{background:'url('+contact[3].url+')',backgroundSize:'100% 100%'}" class="add-left-img"></el-col>
                  <el-col :span="18"  class="add-left-content">地址：成都市高新区高朋东路3号11E1号</el-col>
                  </el-row>
                  <el-row   class="add-left">
                  <el-col :span="3"  :offset="1" :style="{background:'url('+contact[4].url+')',backgroundSize:'100% 100%'}" class="add-left-img"></el-col>
                  <el-col :span="18"  class="add-right-img" >
                    <img :src=contact[5].url />  
                  </el-col>
                  </el-row>
                
              </el-col>
              <el-col :span="16">
                <el-amap vid="amap" class="amap" :center="center" :plugin="plugin"  :zoom="zoom" :zooms="zooms">

                  <el-amap-marker vid="component-marker" :position="position" :label="label" />

                </el-amap>
              </el-col>
              </el-row>
        </div>
      </div>
</div>
</template>
<script>
import { getRequest } from '../../util/api'
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import { AMapManager } from 'vue-amap';
export default {
   data() {
    return {
      menus: [],
      contact:[
        { url:require('../../assets/about/phone.png')},
        { url:require('../../assets/about/email.png')},
        { url:require('../../assets/about/office.png')},
        { url:require('../../assets/about/address.png')},
        { url:require('../../assets/about/lx.png')},
         { url:require('../../assets/about/gzh.png')}
      ],
      content:'',
      activeName: '',
      query:'',
      position: [104.04, 30.62], // 定位

      center: [104.04, 30.62],   // 地图初始化视图中心点
      zoom: 20,
      zooms:[11,20],
      plugin: [                          // 这里放扩展的插件

        {        

          pName: 'Scale',                // 比例尺

          events: {

            init(instance) {

            }

          }

        }

      ],
      label:{
        content:'四川能信科技股份有限公司',
        offset:[-40, -10]
      },
    }
   },
     mounted() {
    this.getMenuChildren(),
    this.getMenuContent(this.$route.query.id)
    this.activeName=this.$route.query.id;
  },
  watch: {
    activeName(newVal) {
      this.$router.push({
        query: {id:`${this.activeName}`}
      })
    },
    '$route.query.id':function(newVal){
          this.activeName=newVal;
           this.getMenuContent(newVal)
    }
  },
   methods: {
      getMenuChildren() {
      let that = this
      let params = {
        pid: 2,
      }
      getRequest('/menus/type',params).then(function(res) {
        if (res.data.meta.code == 1) {
          that.menus = res.data.data;
        }
      })
    },
      aboutMenuSelect(tab, event) {
         let that = this
         that.getMenuContent(tab.name); 
    },

    getMenuContent(key){
       let that = this
      let params = {
        type: key,
      }
      that.content = ''
      getRequest('/menus/info',params).then(function(res) {
        if (res.data.meta.code == 1) {
           that.content = res.data.data
        }
      })
    }
   }

}
</script>
<style>
.add-right-img{
  height: 57px;
  width: 57px;
  margin-top: 10px;
  transition: all 0.6s; 
}
.add-right-img :hover{  
transform: scale(1.9);  
/* transform:matrix(0.866,0.5,-0.5,0.866,0,0); */
}  
.add-left-content{
  height: 32px;
  margin-top: 25px;
  line-height: 32px;
}
.add-left-img{
  height: 32px;
  width: 32px;
  margin-top: 25px;
  margin-right: 18px;
}
.add-left-title{
   height: 77px;
   font-weight: 500;
  font-size: 22px;
  line-height: 77px;
  background: #3199E9;
  text-align: center;
  color: #FFFFFF;
}
.add-left{
  height: 77px;
  border-bottom: 1px dashed  #E0E0E0 ;
}
#amap {

  height: 460px;

  width: 100%;

}
.about{
  width: 99%;
}
</style>
<style src="../../css/banner.css"></style>


// WEBPACK FOOTER //
// src/components/content/About.vue